import request from '@/utils/request'; // export function fetchPollingInfo(data) {
//   return request({
//     url: '/pmsdevice/api/alarm/getPollingInfo',
//     method: 'post',
//     data
//   })
// }

export function fetchPollingList(data) {
  return request({
    url: '/pmsdevice/api/alarm/pollingList',
    method: 'post',
    data: data
  });
}
export function fetchList(data) {
  return request({
    url: '/pmsdevice/api/alarm/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(queryData) {
  return request({
    url: '/pmsdevice/api/alarm/detail',
    method: 'get',
    params: queryData
  });
}
export function fetchDelete(deptId) {
  var data = {
    deptId: deptId
  };
  return request({
    url: '/pmsdevice/api/alarm/delete',
    method: 'post',
    data: data
  });
}
export function fetchDeletes(deptIds) {
  var data = deptIds;
  return request({
    url: '/pmsdevice/api/alarm/deletes',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/pmsdevice/api/dept/create',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/pmsdevice/api/alarm/update',
    method: 'post',
    data: data
  });
}
export function fetchPushAlarm(data) {
  return request({
    url: '/pmsexternal/api/estateManager/pushAlarm',
    method: 'post',
    data: data
  });
}
export function fetchSelectCollectionAllAlarm(data) {
  return request({
    url: '/pmsdevice/api/alarm/selectCollectionAllAlarm',
    method: 'post',
    data: data
  });
} // 90天未修改密码

export function getIsLessSevent(data) {
  return request({
    url: '/userservice/api/person/getIsLessSevent',
    method: 'post',
    data: data
  });
}